"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactPopper = require("react-popper");
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _clone = _interopRequireDefault(require("clone"));
var _setHours = _interopRequireDefault(require("date-fns/setHours"));
var _getHours = _interopRequireDefault(require("date-fns/getHours"));
var _setMinutes = _interopRequireDefault(require("date-fns/setMinutes"));
var _getMinutes = _interopRequireDefault(require("date-fns/getMinutes"));
var _setSeconds = _interopRequireDefault(require("date-fns/setSeconds"));
var _getSeconds = _interopRequireDefault(require("date-fns/getSeconds"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _oxygenInput = _interopRequireDefault(require("@8x8/oxygen-input"));
var _ClockIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/ClockIcon"));
var _oxygenConstants = require("@8x8/oxygen-constants");
var _oxygenConfig = require("@8x8/oxygen-config");
var _TimeSelectorDropdown = _interopRequireDefault(require("./TimeSelectorDropdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable react/jsx-no-bind */
var TIME_PARSE_FORMATS = ['H', 'Hmm', 'H:mm', 'H.mm.ss', 'Hmmss', 'H:mm:ss', 'ha', 'hamm', 'hmma', 'h:mma', 'h:mm a', 'h.mma', 'h.mm a', 'h.mm.ssa', 'h.mm.ss a', 'h:mm:ss a', 'h:mm:ss a', 'hmmssa'];
function TimeSelector(_ref) {
  var hasError = _ref.hasError,
    isDisabled = _ref.isDisabled,
    isLeftIconVisible = _ref.isLeftIconVisible,
    timeDisplayFormat = _ref.timeDisplayFormat,
    size = _ref.size,
    iconLeft = _ref.iconLeft,
    placeholder = _ref.placeholder,
    value = _ref.value,
    id = _ref.id,
    testId = _ref.testId,
    onChange = _ref.onChange,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    theme = _ref.theme;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedTimeValue = _useState4[0],
    setSelectedTimeValue = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasInputError = _useState6[0],
    setHasInputError = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDropdownVisible = _useState8[0],
    setIsDropdownVisible = _useState8[1];
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setInputValue(formatValue());
  }, [value, timeDisplayFormat]);
  (0, _react.useEffect)(function () {
    setHasInputError(false);
    setSelectedTimeValue((0, _clone["default"])(value));
  }, [value]);
  function formatValue() {
    if (!value) {
      return '';
    }
    var _value$hours = value.hours,
      hours = _value$hours === void 0 ? 0 : _value$hours,
      _value$minutes = value.minutes,
      minutes = _value$minutes === void 0 ? 0 : _value$minutes,
      _value$seconds = value.seconds,
      seconds = _value$seconds === void 0 ? 0 : _value$seconds;
    return (0, _format["default"])((0, _setHours["default"])((0, _setMinutes["default"])((0, _setSeconds["default"])(new Date(), seconds || 0), minutes), hours), timeDisplayFormat);
  }
  function parseInputValue(textValue) {
    for (var i = 0; i < TIME_PARSE_FORMATS.length; i += 1) {
      var timeParseFormat = TIME_PARSE_FORMATS[i];
      var result = (0, _parse["default"])(textValue, timeParseFormat, new Date());
      if ((0, _isValid["default"])(result)) {
        return result;
      }
    }
    return undefined;
  }
  function revertSelectedValues() {
    setInputValue(formatValue());
    setHasInputError(false);
    setSelectedTimeValue((0, _clone["default"])(value));
  }
  function onInputValueChange(event) {
    var newInputValue = event.target.value;
    setInputValue(newInputValue);
    if (!newInputValue) {
      setHasInputError(false);
      setSelectedTimeValue(undefined);
      return;
    }
    var parsedTimeValue = parseInputValue(newInputValue);
    if (!(0, _isValid["default"])(parsedTimeValue)) {
      setHasInputError(true);
      setSelectedTimeValue(undefined);
      return;
    }
    setHasInputError(false);
    setSelectedTimeValue({
      hours: (0, _getHours["default"])(parsedTimeValue),
      minutes: (0, _getMinutes["default"])(parsedTimeValue),
      seconds: (0, _getSeconds["default"])(parsedTimeValue)
    });
  }
  function onInputFocus() {
    setIsDropdownVisible(true);
    onOpen();
  }
  function onInputBlur() {
    setIsDropdownVisible(false);
    onClose();
    if (!inputValue) {
      onChange(undefined);
      return;
    }
    if (hasInputError) {
      revertSelectedValues();
      return;
    }
    onChange((0, _clone["default"])(selectedTimeValue));
  }
  function onInputKeyDown(_ref2) {
    var eventKeyCode = _ref2.keyCode;
    if (!inputRef.current) {
      return;
    }
    if (eventKeyCode === _oxygenConstants.keyCode.ENTER) {
      inputRef.current.blur();
      return;
    }
    if (eventKeyCode === _oxygenConstants.keyCode.ESCAPE) {
      revertSelectedValues();
      window.setTimeout(function () {
        return inputRef.current.blur();
      });
    }
  }
  function onDropdownTimeSelect(selectedTime) {
    setHasInputError(false);
    setSelectedTimeValue((0, _clone["default"])(selectedTime));
  }
  var inputMaxLength = timeDisplayFormat.length + 10;
  return /*#__PURE__*/_react["default"].createElement(_reactPopper.Manager, null, /*#__PURE__*/_react["default"].createElement(_reactPopper.Reference, null, function (_ref3) {
    var ref = _ref3.ref;
    return /*#__PURE__*/_react["default"].createElement(_oxygenInput["default"], _extends({
      id: id,
      value: inputValue,
      maxLength: inputMaxLength,
      placeholder: placeholder,
      size: size,
      iconLeft: isLeftIconVisible ? iconLeft : null,
      hasError: hasInputError || hasError,
      isDisabled: isDisabled,
      autoComplete: "off",
      onChange: onInputValueChange,
      ref: ref,
      onFocus: onInputFocus,
      onBlur: onInputBlur,
      onKeyDown: onInputKeyDown,
      theme: theme.input,
      inputRef: inputRef
    }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_INPUT"))));
  }), isDropdownVisible && !hasInputError && !!inputValue && /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, {
    placement: "bottom-start",
    positionFixed: true
  }, function (_ref4) {
    var ref = _ref4.ref,
      style = _ref4.style;
    return /*#__PURE__*/_react["default"].createElement(_TimeSelectorDropdown["default"], {
      selectedTimeValue: selectedTimeValue,
      timeDisplayFormat: timeDisplayFormat,
      testId: "".concat(testId, "_DROPDOWN"),
      onTimeSelect: onDropdownTimeSelect,
      style: style,
      dropdownRef: ref,
      theme: theme
    });
  }));
}
TimeSelector.propTypes = {
  hasError: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isLeftIconVisible: _propTypes["default"].bool,
  timeDisplayFormat: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'default']),
  iconLeft: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].elementType]),
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].shape({
    hours: _propTypes["default"].number,
    minutes: _propTypes["default"].number,
    seconds: _propTypes["default"].number
  }),
  id: _propTypes["default"].string,
  testId: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  theme: _propTypes["default"].object.isRequired
};
TimeSelector.defaultProps = {
  hasError: false,
  isDisabled: false,
  isLeftIconVisible: false,
  timeDisplayFormat: 'h:mm a',
  size: 'default',
  iconLeft: _ClockIcon["default"],
  placeholder: '',
  value: undefined,
  id: undefined,
  testId: 'TIME_SELECTOR',
  onChange: _lodash["default"],
  onOpen: _lodash["default"],
  onClose: _lodash["default"]
};
var _default = (0, _oxygenConfig.withTheme)(TimeSelector, 'timeSelector');
exports["default"] = _default;